export default {
	'no-specialty-materials-to-show': 'لا توجد مواد حسب الاختصاص لهذا الشهر',
}